import { createAction } from '@reduxjs/toolkit';

import type { DeleteFunctionPayload } from '@polyai/stream/commands/handlers/functions/delete-function/schema';
import type {
  EndFunctionCreatePayload,
  StartFunctionCreatePayload,
} from '@polyai/stream/commands/handlers/special-functions/create-function/schema';
import type {
  EndFunctionUpdatePayload,
  StartFunctionUpdatePayload,
} from '@polyai/stream/commands/handlers/special-functions/update-function/schema';

const createStartFunction = createAction<StartFunctionCreatePayload>(
  `specialFunctions/createStartFunction`,
);

const createEndFunction = createAction<EndFunctionCreatePayload>(
  `specialFunctions/createEndFunction`,
);

const updateStartFunction = createAction<StartFunctionUpdatePayload>(
  `specialFunctions/updateStartFunction`,
);

const updateEndFunction = createAction<EndFunctionUpdatePayload>(
  `specialFunctions/updateEndFunction`,
);

const deleteStartFunction = createAction<DeleteFunctionPayload>(
  `specialFunctions/deleteStartFunction`,
);

const deleteEndFunction = createAction<DeleteFunctionPayload>(
  `specialFunctions/deleteEndFunction`,
);

export {
  createEndFunction,
  createStartFunction,
  deleteEndFunction,
  deleteStartFunction,
  updateEndFunction,
  updateStartFunction,
};
